import React from 'react';
import './App.css';
import { Route, Routes } from "react-router-dom";
import Login from './Pages/LandingPage/Login';
import Routing from './Routes';


function App() {
  return (

    <Routes>
      <Route path='/' element={<Login/>}/>
      <Route path='/*' element={<Routing/>}/>
    </Routes>
    
  );
}

export default App;
